import dayjs from "dayjs";
import { computed, defineComponent, ref } from "vue";
import FilePreview from "~/components/FilePreview.vue";
import { Log } from "~/extensions/utils";
import { FileCode, KeyReturnAdrKb, KeyReturnNameKb, RenrakuKb, TaikyoRiyuKb } from "~/extensions/utils/DefineTypes";
import { useTaikyoFilePreview } from "~/pages/taikyo/notification/Models/useTaikyoFilePreview";
import { store } from "~/pages/taikyo/store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
const log = Log.create("TaikyoNotificationCheckCard");
export default defineComponent({
    name: "taikyoNotificationCheckCard",
    components: {
        FilePreview
    },
    props: {
        row: {
            type: Object,
            required: true
        },
        taikyoForInput: {
            type: Object,
            required: true
        },
        result: {
            type: Object,
            required: false
        },
        fileInfo: {
            type: Object,
            required: false
        }
    },
    setup(props) {
        const isMultipleKeiyaku = computed(() => store.taikyoNotificationEntity.taikyoList.filter(x => !x.isDeleted).length > 1);
        const isMMA = myPageStore.personal.isMma;
        const filePreview = useTaikyoFilePreview();
        let date = ref("");
        let time = ref("");
        function applyDateTime(row) {
            if (date.value && time.value) {
                row.keyReturnStrYmd = `${date.value} ${time.value}`;
            }
            date.value = "";
            time.value = "";
        }
        return {
            props,
            isMultipleKeiyaku,
            isMMA,
            date,
            time,
            applyDateTime,
            dayjs,
            myPageStore,
            KeyReturnAdrKb,
            KeyReturnNameKb,
            RenrakuKb,
            TaikyoRiyuKb,
            FileCode,
            ...filePreview
        };
    }
});
